import React from 'react';
import ThemeList from './theme-list';
import { SidebarPanelOpenerButton } from '../../application-controls/index';

class ThemeSwitcherButton extends React.Component {
  render() {
    return (
      <SidebarPanelOpenerButton
        iconClass="mdi mdi-palette"
        label="Themes"
        title="Themes"
        panelComponent={ThemeList}
      />
    );
  }
}

export default ThemeSwitcherButton;